import { render, staticRenderFns } from "./AnalysesOnlineOrderSection.vue?vue&type=template&id=5e696af6&scoped=true&"
import script from "./AnalysesOnlineOrderSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesOnlineOrderSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesOnlineOrderSection.vue?vue&type=style&index=0&id=5e696af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e696af6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e696af6')) {
      api.createRecord('5e696af6', component.options)
    } else {
      api.reload('5e696af6', component.options)
    }
    module.hot.accept("./AnalysesOnlineOrderSection.vue?vue&type=template&id=5e696af6&scoped=true&", function () {
      api.rerender('5e696af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesOnlineOrderSection.vue"
export default component.exports